import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";

import { push, goBack } from "react-router-redux";
import { connect } from "react-redux";
import { signout } from "../../redux/actions/Signin";

import DropdownMenu from "./DropdownMenu";
import ArrowLeft from "../Icons/ArrowLeft";
import ArrowRight from "../Icons/ArrowRight";

import SystemNotificationDialog from "./NotificationBell/SystemNotificationDialog";
import RecommendRelocationPersonnelNotificationDialog from "./NotificationBell/RecommendRelocationPersonnelNotificationDialog";
import ChildAccountConfirmDialog from "../AccountSetting/dialogs/ChildAccountConfirmDialog";
import NotificationBell from "./NotificationBell/NotificationBell";
import * as actions from "../../redux/actions/Notification";
import * as AccountSettingActions from "../../redux/actions/AccountSetting";
import { isEnableCorporateNumberAssign } from '../../utils/userOptionUtils';
import { hasEverBeenEnabledExportPlan } from '../../utils/planUtils';
import { canViewDownloadHistory } from '../../utils/utils';

const styles = {
  root: {
    width: "100%",
    zIndex: 1,
  },

  title: {
    margin: "0 7px",
  },

  appBar: {
    height: "60px",
    color: "#181819",
    background: "#F4F6F9",
    zIndex: 1,
  },

  appBarDark: {
    height: "60px",
    color: "#FFFFFF",
    background: "#040E35",
    zIndex: 1,
  },

  toolBar: {
    minHeight: "unset",
    padding: 0,
    position: "inherit",
    height: "100%",
  },

  proxyLoginLabel: {
    fontSize: 13,
    padding: "8px 16px",
  },

  menuBtn: {
    marginRight: "16px",
  },

  backBtn: {
    margin: 0,
    height: "60px",
    width: "60px",
    minWidth: "unset",
    fontSize: 13,
  },

  iconButton: {
    height: "24px",
    width: "24px",
    marginRight: "16px",
  },

  dot: {
    background: "#F03A47",
    width: "5px",
    height: "5px",
    borderRadius: "50%",
    position: "absolute",
    top: 1,
    left: 2,
  },

  logo: {
    width: "28px",
    paddingLeft: "20px",
    cursor: "pointer",
  },

  titleContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    marginLeft: "12px",
  },

  dropdown: {
    minWidth: "160px",
  },
};

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showProxyLoginChildAccountDialog: false,
      childUser: null,
      moreAccounts: false,
    };
  }

  componentWillMount() {
    this.props.getNotificationsLatest();
  }

  componentDidUpdate(prevProps) {
    if (this.props.user !== prevProps.user) {
      if (this.props.user && this.props.user.ownership_authority_flag) {
        this.props.getChildUsers();
      }
    }
  }

  /*** Event Handlers ***/

  toggleProxyLoginChildAccountDialog = (childUser) => {
    this.setState({
      showProxyLoginChildAccountDialog:
        !this.state.showProxyLoginChildAccountDialog,
      childUser: childUser,
    });
  };

  handleClick = () => {
    this.setState({
      moreAccounts: true,
    });
  };

  goToFaq = () => {
    window.open(`${window.location.origin}/how-to`, "_blank");
  };

  getMenuItems = () => {
    const { location, user } = this.props;

    const defaultMenu = [
      { name: "ログアウト", func: () => this.props.logout("/signin") },
    ];

    if (
      location.includes("/reset-password") ||
      location.includes("update-security-question")
    ) {
      return defaultMenu;
    }

    if (user) {
      const canShowCorporateNumberAssign = isEnableCorporateNumberAssign(user);
      // 一度でもエクスポート可能なプランを契約していて、かつ閲覧権限がある場合のみダウンロード履歴を表示する
      const canShowDownloadHistory = hasEverBeenEnabledExportPlan(user) && canViewDownloadHistory(user);

      return [
        {
          name: "ダッシュボード",
          func: this.props.goToOrderDashboard,
        },
      ]
        .concat([
          { name: "注文履歴", func: this.props.goToOrderList },
          ...(canShowDownloadHistory ? [
            { name: "ダウンロード履歴", func: this.props.goToDownloadHistory },
          ] : []),
          {
            name: "レター文面作成",
            func: this.props.goToLetterGenerate,
          },
          ...(canShowCorporateNumberAssign ? [
            {
              name: "法人番号AI付与",
              func: this.props.goToCorporateNumberAssign,
              isNew: true,
            },
          ] : []),
          {
            name: "キーマンデータベース",
            func: this.props.goToExecutiveList,
          },
          { name: "自社リスト", func: this.props.goToHouseList },
          {
            name: "アカウント管理",
            func: user.ownership_authority_flag
              ? this.props.goToChildAccountSetting
              : this.props.goToAccountSetting,
          },
          { name: "ヘルプ", func: this.goToFaq },
          {
            name: "ログアウト",
            func: () => this.props.logout("/keyman-letter-signin"),
          },
        ])
        .concat(
          user && user.is_proxy_login
            ? [
              {
                name: "親アカウントへ戻る",
                func: () => this.props.getProxyLoginParentUser(),
              },
            ]
            : []
        );
    }

    return defaultMenu;
  };

  renderProxyLoginChildAccountDialog = () => {
    const { childUser } = this.state;
    return (
      <ChildAccountConfirmDialog
        isOpen={this.state.showProxyLoginChildAccountDialog}
        toggleDialog={this.toggleProxyLoginChildAccountDialog}
        title={
          childUser && childUser.name
            ? `${childUser.name}として代理ログインする`
            : "代理ログインする"
        }
        childUser={childUser}
        type="proxy_login"
        func={this.props.getProxyLoginChildUser}
      />
    );
  };

  renderSystemNotificationDialog = () => {
    if (this.props.showSystemNotificationDialog) {
      return (
        <SystemNotificationDialog
          isOpen={this.props.showSystemNotificationDialog}
          toggleDialog={this.props.toggleSystemNotificationDialog}
          item={this.props.notification_item}
        />
      );
    }
  };

  renderRecommendRelocationPersonnelNotificationDialog = () => {
    if (this.props.showRecommendRelocationPersonnelNotificationDialog) {
      return (
        <RecommendRelocationPersonnelNotificationDialog
          isOpen={this.props.showRecommendRelocationPersonnelNotificationDialog}
          toggleDialog={this.props.toggleRecommendRelocationPersonnelNotificationDialog}
          item={this.props.notification_item}
        />
      );
    }
  };

  render() {
    const { classes, location, secondaryTitle, onTitleClicked, user } =
      this.props;

    const menuItems = this.getMenuItems();

    const displayCount = 5
    let childAccounts = [];
    // 子アカウントを取得した場合は代理ログインするためにヘッダー右上のセレクトボックスを追加する
    if (this.props.childUsers) {
      this.props.childUsers.map((childUser) => {
        let menu = {};
        menu.name = childUser.name;
        menu.func = () => this.toggleProxyLoginChildAccountDialog(childUser);
        // 「もっと見る...」がクリックされていない場合は5件まで表示する
        if (!this.state.moreAccounts && childAccounts.length < displayCount) {
          childAccounts.push(menu);
        } else if (this.state.moreAccounts) {
          childAccounts.push(menu);
        }
        return childAccounts;
      });

      // 5件以上アカウントがある場合は「もっと見る」を表示する
      if (
        this.props.childUsers &&
        childAccounts.length >= displayCount &&
        !this.state.moreAccounts
      ) {
        let moreMenu = {};
        moreMenu.name = "もっと見る...";
        moreMenu.func = () => this.setState({ moreAccounts: true });
        childAccounts.push(moreMenu);
      }
    }

    let proxyLoginChildAccountDialog;

    if (this.state.showProxyLoginChildAccountDialog) {
      proxyLoginChildAccountDialog = this.renderProxyLoginChildAccountDialog();
    }

    let backBtn = (
      <Button
        className={classes.backBtn}
        onClick={this.props.goBack}
        color="default"
        aria-label="Back"
      >
        <ArrowLeft color="#71737B" width={20} height={20} />
      </Button>
    );

    const src = (this.props.title === "キーマンデータベース") ? require("../../assets/images/keyman-database-logo-white.svg") : require("../../assets/images/smart-letter-logo.svg");

    let logo =
      this.props.type === "dark" ? (
        <img
          alt="posto.svg"
          src={src}
          className={classes.logo}
          onClick={this.props.goToDashboard}
        />
      ) : undefined;

    if (this.props.hasBackBtn === false) {
      backBtn = "";
    }

    return (
      <div className={classes.root} style={this.props.style}>
        <AppBar
          position="static"
          color="default"
          className={
            this.props.type === "dark" ? classes.appBarDark : classes.appBar
          }
          elevation={0}
        >
          <Toolbar className={classes.toolBar}>
            {backBtn}
            {logo}

            <div className={classes.titleContainer}>
              <Typography
                variant="subheading"
                color="inherit"
                className={classes.title}
                onClick={onTitleClicked}
                style={{ cursor: onTitleClicked ? "pointer" : "auto" }}
              >
                {this.props.title}
              </Typography>
              {secondaryTitle && (
                <ArrowRight height={15} width={15} color="#FFFFFF" />
              )}
              {secondaryTitle && (
                <Typography
                  variant="subheading"
                  color="inherit"
                  className={classes.title}
                >
                  {secondaryTitle}
                </Typography>
              )}
            </div>

            {!location.includes("reset-password") && (
              <NotificationBell
                notifications={this.props.notifications}
                isLoading={this.props.isLoadingNotifications}
                type={this.props.type}
                goTo={this.props.goTo}
                postNotificationsMark={this.props.postNotificationsMark}
                toggleSystemNotificationDialog={
                  this.props.toggleSystemNotificationDialog
                }
                toggleRecommendRelocationPersonnelNotificationDialog={
                  this.props.toggleRecommendRelocationPersonnelNotificationDialog
                }
              />
            )}
            {user && user.is_proxy_login && (
              <div className={classes.proxyLoginLabel}>
                {user.name + "（代理ログイン中）"}
              </div>
            )}
            {user &&
              !!childAccounts.length &&
              !!user.ownership_authority_flag && (
                <div className={classes.menuBtn}>
                  <DropdownMenu
                    menuTitle={user.name + "（オーナー）"}
                    menuItems={childAccounts}
                    dropdownIcon={true}
                    type={this.props.type}
                    classes={{
                      dropdown: classes.dropdown,
                    }}
                  />
                </div>
              )}

            <div className={classes.menuBtn}>
              <DropdownMenu
                menuTitle="メニュー"
                menuItems={menuItems}
                dropdownIcon={true}
                type={this.props.type}
              />
            </div>
          </Toolbar>
        </AppBar>
        {proxyLoginChildAccountDialog}
        {this.renderSystemNotificationDialog()}
        {this.renderRecommendRelocationPersonnelNotificationDialog()}
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  secondaryTitle: PropTypes.string,
  hasBackBtn: PropTypes.bool,
  type: PropTypes.string,
  style: PropTypes.object,
  onTitleClicked: PropTypes.func,
  location: PropTypes.string,
  getNotificationsLatest: PropTypes.func,
  user: PropTypes.object,
  getChildUsers: PropTypes.func,
  childUsers: PropTypes.object,
  goTo: PropTypes.func,
  goToDashboard: PropTypes.func,
  goToAccountSetting: PropTypes.func,
  goToChildAccountSetting: PropTypes.func,
  goToExecutiveList: PropTypes.func,
  goToOrderDashboard: PropTypes.func,
  goToOrderList: PropTypes.func,
  goToDownloadHistory: PropTypes.func,
  goToLetterGenerate: PropTypes.func,
  goToCorporateNumberAssign: PropTypes.func,
  goToHouseList: PropTypes.func,
  goBack: PropTypes.func,
  logout: PropTypes.func,
  isLoadingNotifications: PropTypes.bool,
  notifications: PropTypes.array,
  postNotificationsMark: PropTypes.func,
  showSystemNotificationDialog: PropTypes.bool,
  showRecommendRelocationPersonnelNotificationDialog: PropTypes.bool,
  toggleSystemNotificationDialog: PropTypes.func,
  toggleRecommendRelocationPersonnelNotificationDialog: PropTypes.func,
  getProxyLoginParentUser: PropTypes.func,
  getProxyLoginChildUser: PropTypes.func,
  notification_item: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    location: state.router.location.pathname,
    notifications: state.notification.latest_notifications
      .toIndexedSeq()
      .toArray(),
    isLoadingNotifications: state.notification.isLoadingNotificationsLatest,
    user: state.accountSetting.user,
    childUsers: state.accountSetting.childUsers,
    showSystemNotificationDialog:
      state.notification.showSystemNotificationDialog,
    showRecommendRelocationPersonnelNotificationDialog:
      state.notification.showRecommendRelocationPersonnelNotificationDialog,
    notification_item: state.notification.notification_item,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToDashboard: () => dispatch(push("/")),
    goToAccountSetting: () => dispatch(push("/setting")),
    goToChildAccountSetting: () => dispatch(push("/setting/child-accounts")),
    goToExecutiveList: () => dispatch(push("/executive-list")),
    goToOrderDashboard: () => dispatch(push("/order-dashboard")),
    goToOrderList: () => dispatch(push("/orders")),
    goToDownloadHistory: () => dispatch(push("/download-history")),
    goToLetterGenerate: () => dispatch(push("/letter-generate")),
    goToCorporateNumberAssign: () => dispatch(push("/corporate-number-assign")),
    goToHouseList: () => dispatch(push("/house-list")),
    goBack: () => dispatch(goBack()),
    logout: (url) => {
      dispatch(push(url));
      dispatch(signout());
    },
    goTo: (url, state) => dispatch(push(url, state)),
    getNotificationsLatest: () => dispatch(actions.getNotificationsLatest()),
    getChildUsers: (data) => dispatch(AccountSettingActions.getChildUsers(data)),
    getProxyLoginChildUser(id) {
      dispatch(AccountSettingActions.getProxyLoginChildUser(id));
    },
    getProxyLoginParentUser: () => dispatch(AccountSettingActions.getProxyLoginParentUser()),
    postNotificationsMark: (id, data) =>
      dispatch(actions.postNotificationsMark(id, data)),
    toggleSystemNotificationDialog: (item) =>
      dispatch(actions.toggleSystemNotificationDialog(item)),
    toggleRecommendRelocationPersonnelNotificationDialog: (item) =>
      dispatch(actions.toggleRecommendRelocationPersonnelNotificationDialog(item)),
  };
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Header)
);



// WEBPACK FOOTER //
// ./src/components/common/Header.jsx